import { useTranslation } from '@jq4race/i18n';
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

interface MfaQrCodeProps {
  otpauthUri: string;
}

export function MfaQrCode({ otpauthUri }: MfaQrCodeProps) {
  const { t } = useTranslation('auth');
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(otpauthUri, { width: 220, margin: 1 })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [otpauthUri]);

  if (!dataUrl) {
    return (
      <div
        role="status"
        aria-label={t('setupMfa.qrGenerating')}
        className="flex h-[220px] w-[220px] items-center justify-center rounded-sm bg-jq-surface-1"
      />
    );
  }

  return (
    <img
      src={dataUrl}
      alt={t('setupMfa.qrAlt')}
      className="h-[220px] w-[220px] rounded-sm border border-border"
    />
  );
}
